module.exports = __webpack_public_path__ + "static/media/BackExtensionMale.fc7fc8fb.svg";